import { render, staticRenderFns } from "./ClaimsProcessTab.vue?vue&type=template&id=3762cd9a&scoped=true"
import script from "./ClaimsProcessTab.vue?vue&type=script&lang=js"
export * from "./ClaimsProcessTab.vue?vue&type=script&lang=js"
import style0 from "./ClaimsProcessTab.vue?vue&type=style&index=0&id=3762cd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762cd9a",
  null
  
)

export default component.exports